import { useMemo, useState } from 'react';
import { FormField, SitecoreForm } from '@sitecore-jss/sitecore-jss-forms';
import { NextRouter, withRouter } from 'next/router';

import { getSiteNameFromUrl, SiteName } from 'lib/utils';

import { FieldValuesProvider } from '../contexts/FormValues/FieldValuesContext';
import { PrefillProvider } from '../contexts/PrefillContext';
import { JabraFormModel } from '../types/jabraFormModel';
import { buildFieldMaps } from '../utilities/conditionalRendering';
import DefaultForm from './FormVariants/DefaultForm';
import TspForm from './FormVariants/TspForm';

const JssForm = ({ fields, router }: { fields: SitecoreForm; router: NextRouter }) => {
  const [currentFields, setCurrentFields] = useState<FormField[]>(fields.fields);

  const { fieldKeyMap, initialFieldValues } = useMemo(
    () => buildFieldMaps(currentFields),
    [currentFields]
  );

  const { prefillMap } = fields.metadata as JabraFormModel;

  const isTsp = getSiteNameFromUrl(router.asPath) === SiteName.TieredServicePortal;
  const FormVariant = isTsp ? TspForm : DefaultForm;

  return (
    <PrefillProvider prefillMap={prefillMap ?? ''}>
      <FieldValuesProvider initialFieldValues={initialFieldValues} fieldKeyMap={fieldKeyMap}>
        <FormVariant fields={fields} router={router} onNextForm={setCurrentFields} />
      </FieldValuesProvider>
    </PrefillProvider>
  );
};

export default withRouter(JssForm);
